import { render, staticRenderFns } from "./HomeFeaturedProducts.vue?vue&type=template&id=44c964fe&scoped=true&"
import script from "./HomeFeaturedProducts.vue?vue&type=script&lang=ts&"
export * from "./HomeFeaturedProducts.vue?vue&type=script&lang=ts&"
import style0 from "./HomeFeaturedProducts.vue?vue&type=style&index=0&id=44c964fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c964fe",
  null
  
)

export default component.exports